import React, { useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import CreateTicketForm from 'components/tickets/formSection/createTicketForm/createTicketForm';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';

const CreateTicket = ({
  createTicket,
  documentUploadUrl,
  documentUrlData,
  getSearchUser,
  searchUser,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [createTicketData, setCreateTicketData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const createTicketHandle = async () => {
    if (createTicketData === null) {
      setIsFiled(true);
    } else {
      setIsFiled(false);
      setIsLoading(true);
      await createTicket(createTicketData);
      setIsLoading(false);
      setIsModal(true);
    }
  };
  const handleModalHide = () => setIsModal(false);
  const headerBtns = () => {
    return (
      <Button
        className="btn btn-primary d-none d-md-inline-block"
        onClick={createTicketHandle}
      >
        {' '}
        {localization.raiseTicket} <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.createTicket}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      className={isFiled ? 'requiredFileds' : ''}
    >
      <PanelCardWithHeading title={localization.ticketDetails}>
        <CreateTicketForm
          getSearchUser={getSearchUser}
          searchUser={searchUser}
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          createTicketSubmit={(obj) => setCreateTicketData(obj)}
        />
      </PanelCardWithHeading>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={`${baseUrl}/ticket-listing`}
            className="btn btn-primary mb-4"
          >
            {localization.viewTicketsList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default CreateTicket;
